interface TriStateProps {
  label: string;
  /** null/undefined = não avaliado; false = avaliado e ausente; true = observado. */
  value: boolean | null | undefined;
  onChange: (value: boolean | null) => void;
  disabled?: boolean;
}

const OPTIONS: Array<{ key: "unknown" | "absent" | "present"; text: string; value: boolean | null }> = [
  { key: "unknown", text: "Não avaliado", value: null },
  { key: "absent", text: "Ausente", value: false },
  { key: "present", text: "Observado", value: true },
];

function currentKey(value: boolean | null | undefined) {
  if (value === true) return "present";
  if (value === false) return "absent";
  return "unknown";
}

/**
 * Indicador em três estados. O manual do CTA separa "não observado" de "ausente":
 * uma caixa de seleção só distingue marcado de desmarcado e grava o segundo como
 * "ausente", o que afirma algo que ninguém verificou.
 */
export default function TriState({ label, value, onChange, disabled }: TriStateProps) {
  const active = currentKey(value);
  return (
    <div className="flex items-center justify-between gap-3 py-1.5">
      <span className="text-sm text-foreground-700">{label}</span>
      <div role="radiogroup" aria-label={label} className="inline-flex rounded-lg border border-background-200 overflow-hidden shrink-0">
        {OPTIONS.map((o) => {
          const selected = active === o.key;
          const tone =
            !selected
              ? "bg-white text-foreground-500 hover:bg-background-50"
              : o.key === "present"
                ? "bg-warning-100 text-warning-800 font-semibold"
                : o.key === "absent"
                  ? "bg-primary-100 text-primary-800 font-semibold"
                  : "bg-background-100 text-foreground-700 font-medium";
          return (
            <button
              key={o.key}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange(o.value)}
              className={`px-2.5 py-1 text-xs transition-colors border-l first:border-l-0 border-background-200 ${tone} ${
                disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
              }`}
            >
              {o.text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
